export default __webpack_public_path__ + "1.18.20/static/media/libreView.eba75fec.svg";